import { render, staticRenderFns } from "./NovoPedidoInsumosView.vue?vue&type=template&id=6716d2d1&"
import script from "./NovoPedidoInsumosView.vue?vue&type=script&lang=js&"
export * from "./NovoPedidoInsumosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports